<template>
  <div>
    <b-card style="margin:1%">
      <b-row>
        <b-col md="2"/>
        <b-col md="6">
          <b-form-group label-align="right" :label="$t('Created on')" disabled label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="userCreateDate"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Created by')" disabled label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input v-model="userLastChangeDate"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Last modified on')" disabled label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="whoCreate"/>
          </b-form-group>
          <b-form-group label-align="right" :label="$t('Modified by')" disabled label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="whoChange"/>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import moment from 'moment'

export default {
  props: {
    userInfo: null,
    currentRow: null
  },
  data () {
    return {
      whoChange: null,
      whoCreate: null,
      systemUsers: null,
      userCreateDate: moment().format('MM-DD-YYYY'),
      userLastChangeDate: moment().format('MM-DD-YYYY')
    }
  },
  methods: {
    async load () {
      this.systemUsers = await axiosInstance.get(this.$store.getters.API_USERS_SYSTEMUSERS_SHORT).then(response => { return response.data })
      for (let i in this.systemUsers) {
        if (this.systemUsers[i].user_id === this.userInfo.who_create) {
          this.whoCreate = this.systemUsers[i]
        }
        if (this.systemUsers[i].user_id === this.userInfo.who_change) {
          this.whoChange = this.systemUsers[i]
        }
      }
      this.whoCreate = this.whoCreate.login + ' (' + this.whoCreate.user_id + ')'
      this.whoChange = this.whoChange.login + ' (' + this.whoChange.user_id + ')'
    }
  },
  watch: {
    userInfo: function (val) {
      this.userCreateDate = moment(Number(val.create_date) * 1000).format('MM-DD-YYYY')
      this.userLastChangeDate = moment(Number(val.last_change_date) * 1000).format('MM-DD-YYYY')
      this.load()
    }
  },
  mounted () {
    if (this.userInfo) {
      this.userCreateDate = moment(Number(this.userInfo.create_date) * 1000).format('MM-DD-YYYY')
      this.userLastChangeDate = moment(Number(this.userInfo.last_change_date) * 1000).format('MM-DD-YYYY')
      this.load()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/additionalInfo/main.vue